module.exports = __webpack_public_path__ + "static/4-95bba13fa524c7563e9e7428bd45649d.jpg";